/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const GraduationCap = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M22 10v6M2 10l10-5 10 5-10 5z" }],
    ["path", { d: "M6 12v5c3 3 9 3 12 0v-5" }]
  ]
];

export { GraduationCap as default };
//# sourceMappingURL=graduation-cap.js.map
